import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { tableBank } from "../../../../data/mock/table";
import { message } from "antd";
import '../../../../App.css'

export const UseFetchUserSchedule = (shift) => {
  return useQuery(
    ["getFetchUserSchedule", shift],
    async () => {
      try {
        const endpoint = `/api/v1/users/schedule/${shift}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Users..");
      }
    }
  );
};

// ดึงข้อมูลวันหยุดทั้งหมด
export const UseFetchSchedule = (selectMonth) => {
  return useQuery(
    ["getFetchHolidays"],
    async () => {
      try {
        const endpoint = `/api/v1/schedule?month=${selectMonth}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Holidays..");
      }
    }
  );
};


export const UseFetchCreateSchedule = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/schedule`;
      const result = POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Create Schedule..");
    }
  });
};

export const UseFetchUserWorkSchedule = (userId, month, year) => {
  return useQuery(
    ["getUserWorkSchedule", userId, month, year],
    async () => {
      try {
        const endpoint = `/api/v1/schedule/user/${userId}/${month}/${year}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load User Work Schedule..");
        return [];
      }
    },
    {
      enabled: !!userId && !!month && !!year,
    }
  );
};
